import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import { authModule } from './modules/auth';
import { themeModule } from './modules/theme';
import { partnersArgocdModule, partnersModule, partnersPageModule } from './modules/partners';
import { entityHeaderModule } from './modules/entity-header';
import { toolsModule } from './modules/tools';

export default createApp({
  features: [catalogPlugin, navModule, homeModule, authModule, themeModule, partnersModule, partnersArgocdModule, partnersPageModule, toolsModule, entityHeaderModule],
});
